import Region from '@/creditflowresearch/domain/Region/Region';
import { RegionType } from '@/creditflowresearch/domain/Region/RegionType';
import { APAC_REGION_ID, APAC_ABBREVIATION } from '@/creditflowresearch/domain/Region/constants';
import { APAC_MARKET_ID } from '@/creditflowresearch/domain/Market/constants';

class ApacRegion extends Region {
  static readonly REGION_ID: string = APAC_REGION_ID;

  static readonly ABBREVIATION: string = APAC_ABBREVIATION;

  static readonly TYPE: RegionType = RegionType.APAC;

  protected getMarketIdForRegion(): string | null {
    return APAC_MARKET_ID;
  }
}

export default ApacRegion;
